
AOS.init();

var swiper = new Swiper(".homeSwiper1", {
    slidesPerView: 1.1,
    spaceBetween: 20,
    loop: true,
    breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 30,
        },
    },
});

var swiper2 = new Swiper(".testimonialsSwiper2", {
    slidesPerView: 1,
    spaceBetween: 30,
    breakpoints: {
        768: {
            slidesPerView: 1.5,
        },
        992: {
            slidesPerView: 2.4,
        },
    },
});


var swiper3 = new Swiper(".accreditationsSwiper", {
    slidesPerView: 2,
    spaceBetween: 20,
    slidesPerGroup: 2,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
        },
    },
    breakpoints: {
        768: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 5,
        },
    },
});

var swiper4 = new Swiper(".newsSwiper", {
    slidesPerView: 1.1,
    spaceBetween: 20,
    breakpoints: {
        768: {
          slidesPerView: 2.2,
          spaceBetween: 30,
        },
    },
});


var swiper5 = new Swiper(".floor-type-swiper", {
    slidesPerView: 1.1,
    spaceBetween: 20,
    breakpoints: {
        992: {
            slidesPerView: 1.7,
            spaceBetween: 30,
        },
        1200: {
            slidesPerView: 2.2,
            spaceBetween: 30,
        },
    },
    navigation: {
        nextEl: ".floor-type-next",
        prevEl: ".floor-type-prev",
    },
    allowTouchMove: true,
});


var swiper6 = new Swiper(".testimonialsSwiper3", {
    slidesPerView: 1,
    spaceBetween: 50,
    breakpoints: {
        992: {
            slidesPerView: 2,
            spaceBetween: 100,
        },
        1200: {
            slidesPerView: 2,
            spaceBetween: 150,
        },
        // 1200: {
        //     slidesPerView: 2.5,
        // },
        // 1400: {
        //     slidesPerView: 3,
        // },
    },
});

var swiper7 = new Swiper(".caseSwiper", {
    slidesPerView: 1.1,
    spaceBetween: 20,
    breakpoints: {
        768: {
          slidesPerView: 1.5,
          spaceBetween: 30,
        },
    },
    navigation: {
        nextEl: ".caseSwiper-next",
        prevEl: ".caseSwiper-prev",
    },
    allowTouchMove: true,
});

var swiper8 = new Swiper(".gallerySwiper", {
    slidesPerView: 1.1,
    spaceBetween: 20,
    breakpoints: {
        768: {
          slidesPerView: 1.5,
          spaceBetween: 30,
        },
    },
});

var swiper8 = new Swiper(".downloadSwiper", {
    slidesPerView: 1.1,
    spaceBetween: 20,
    breakpoints: {
        768: {
          slidesPerView: 1.5,
          spaceBetween: 30,
        },
    },
    allowTouchMove: true,
});

var swiper6 = new Swiper(".testimonialsSwiper4", {
    slidesPerView: 1,
    spaceBetween: 50,
    breakpoints: {
        992: {
            slidesPerView: 2,
            spaceBetween: 100,
        },
        1200: {
            spaceBetween: 150,
        },
        // 1200: {
        //     slidesPerView: 2.5,
        // },
        // 1400: {
        //     slidesPerView: 3,
        // },
    },
});

// img changing hover
const typeImg = document.getElementById('floors-type-img');
function changeImg(e, url) {
    typeImg.src = url;
}


// section Latest scroll handler
if (document.getElementById('testimonials')) {
    window.addEventListener('scroll', () => {
        var e = document.getElementById('testimonials');
        var offset = {y:0};
        while (e) {
            offset.y += e.offsetTop;
            e = e.offsetParent;
        }
        if (document.documentElement && (document.documentElement.scrollTop)) {
            offset.y -= document.documentElement.scrollTop;
        }
        else if (document.body && (document.body.scrollTop)){
            offset.y -= document.body.scrollTop;
        }
        else if (window.pageYOffset) {
            offset.y -= window.pageYOffset;
        }
        document.body.style.setProperty('--scroll', ((offset.y * -4 ) / document.getElementById('testimonials').offsetHeight )  );
    }, false);
}


if (document.getElementById('r-latest')) {
    window.addEventListener('scroll', () => {
        var e = document.getElementById('r-latest');
        var offset = {y:0};
        while (e) {
        offset.y += e.offsetTop;
        e = e.offsetParent;
        }
        if (document.documentElement && (document.documentElement.scrollTop)) {
        offset.y -= document.documentElement.scrollTop;
        }
        else if (document.body && (document.body.scrollTop)) {
        offset.y -= document.body.scrollTop;
        }
        else if (window.pageYOffset) {
        offset.y -= window.pageYOffset;
        }
        document.body.style.setProperty('--scroll2', (((offset.y - 200) * -2 ) / document.getElementById('r-latest').offsetHeight ) );
    }, false);
}




// top bar sticky page menu
if (document.getElementById('top-offset-indicator') && document.getElementById("breadcrumb-bar-hidden")) {
    const bar = document.getElementById("breadcrumb-bar-hidden");
    const top_bar = document.getElementById("sticky-top-bar");

    window.addEventListener('scroll', () => {

        var e = document.getElementById('top-offset-indicator');
        var offset = {y:0};
        while (e) {
            offset.y += e.offsetTop;
            e = e.offsetParent;
        }
        if (document.documentElement && (document.documentElement.scrollTop)) {
            offset.y -= document.documentElement.scrollTop;
        }
        else if (document.body && (document.body.scrollTop)) {
            offset.y -= document.body.scrollTop;
        }
        else if (window.pageYOffset) {
            offset.y -= window.pageYOffset;
        }

        if (offset.y < 1) {
            bar.style.display = "flex";
            top_bar.style.backgroundColor = "#fff";
            top_bar.style.boxShadow = "0 0 10px rgba(0,0,0,0.2)";
        } else {
            bar.style.display = "none";
            top_bar.style.backgroundColor = "transparent";
            top_bar.style.boxShadow = "none";
        }

    }, false);
}




// big circle path show
if (document.getElementsByClassName('path-circle-big')) {

    window.addEventListener('scroll', () => {

        var allBigCirclePath = Array.from(document.getElementsByClassName('path-circle-big'));

            for (let i = 0; i < allBigCirclePath.length; i++) {
            var e = allBigCirclePath[i];

            var offset = {y:0};
            while (e) {
                offset.y += e.offsetTop;
                e = e.offsetParent;
            }
            if (document.documentElement && (document.documentElement.scrollTop)) {
                offset.y -= document.documentElement.scrollTop;
            }
            else if (document.body && (document.body.scrollTop)) {
                offset.y -= document.body.scrollTop;
            }
            else if (window.pageYOffset) {
                offset.y -= window.pageYOffset;
            }

            //console.log(offset.y);

            let height = window.innerHeight;

            if (offset.y < (height / 2) ) {
                //allBigCirclePath[i].style.opacity = "1";
                allBigCirclePath[i].style.transform = "translateX(-50%) scale(1)";

            } else {
                //allBigCirclePath[i].style.opacity = "0";
                allBigCirclePath[i].style.transform = "translateX(-50%) scale(0)";
            }
        }

    }, false);
}


//blog filter category
if (document.getElementById('btnCategory') && document.getElementById('filterList')) {
    const form = document.getElementById('newsOrder');
    const filterList = document.getElementById('filterList');
    const buttonCategory = document.getElementById('btnCategory');

    buttonCategory.onclick = function() {
        filterList.classList.toggle("show-item");
    };
    var nodes = filterList.childNodes;
    for(var i = 0; i < nodes.length; i++) {
        nodes[i].onclick = function() {
            filterList.classList.toggle("show-item");
            buttonCategory.innerHTML = this.innerHTML;
            document.getElementById('chosenOrder').value = this.innerHTML;
            var sortDirection = this.getAttribute('data-sort');
            var urlParams = new URLSearchParams(window.location.search);
            urlParams.set('sort', sortDirection);
            form.action = form.action + 'sort=' + sortDirection;
            form.submit();
        }
    };
}


// form validation
(function () {
    'use strict'

    var forms = document.querySelectorAll('.needs-validation')

    Array.prototype.slice.call(forms)
        .forEach(function (form) {
            form.addEventListener('submit', function (event) {
            if (!form.checkValidity()) {
                event.preventDefault()
                event.stopPropagation()
            }

            form.classList.add('was-validated')
        }, false)
    })
})()

if (document.getElementById('hamburger')) {
        document.getElementById('hamburger').addEventListener('click', function () {
        document.getElementById('menu-container').classList.toggle('position-fixed');
    });
}
